import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  note?: string;
  dark?: boolean;
  id?: string;
};
export function SectionCTA({
  label,
  note = 'Instant digital access · One-time payment of $27 USD',
  dark = false,
  id
}: SectionCTAProps) {
  return <div className="mt-10 flex flex-col items-center text-center md:mt-14" data-id="element-102" data-mp="1qad3cjmd6qq9">
      <CTAButton id={id} label={label} data-id="element-103" data-mp="1blyxs0xkco60" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-sm font-medium ${dark ? 'text-white/75' : 'text-muted'}`} data-id="element-104" data-mp="1bkxexaab2xdq">
        <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-105" data-mp="12nmy79epyg1f" />
        {note}
      </p>
    </div>;
}